import { Box, Typography, useTheme } from "@mui/material";
import { useState } from "react";
import OTPInput from "../../components/OTPInput/OTPInput";

function LoginOTPInput(props: {
  value: string | undefined;
  onValueChange: (value: string) => void;
  footerMessage?: React.ReactNode | string;
  showTitle?: boolean;
  hasError?: boolean;
  lowerFooter?: React.ReactNode | string | null;
}) {
  const {
    value,
    onValueChange: setValue,
    footerMessage,
    hasError = false,
    lowerFooter = null,
  } = props;
  const { palette } = useTheme();

  const [{ otp, numInputs, inputType }, setConfig] = useState({
    otp: value || "",
    numInputs: 6,
    inputType: "text" as const,
  });

  const handleOTPChange = (otp: string) => {
    setConfig((prevConfig) => ({ ...prevConfig, otp }));
    setValue(otp);
  };

  const inputStyle = {
    width: '64px',
    height: '64px',
    minHeight: '64px',
    margin: '0 4px',
    fontSize: '30px',
    borderRadius: '8px',
    border: '1px solid #E4E4E4',
    boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.05)',
    backgroundColor: '#FFFFFF',
    color: '#333333',
    textAlign: 'center' as const,
    outline: 'none',
  }

  return (
    <Box>
      <OTPInput
        inputStyle={inputStyle}
        numInputs={numInputs}
        onChange={handleOTPChange}
        value={otp}
        inputType={inputType}
        hasError={hasError}
        renderInput={(props) => <input {...props} />}
      />
      {footerMessage ? (
        <Typography sx={{ mt: 1, color: palette.text.secondary }}>
          {footerMessage}
        </Typography>
      ) : null}
      {lowerFooter ? (
          <Typography sx={{ mt: 1, color: palette.text.secondary }}>
            {lowerFooter}
          </Typography>
      ) : null}
    </Box>
  );
}

export default LoginOTPInput;
